import { c as _c } from "react/compiler-runtime";
import { Hidden } from '@/components/Atoms/Hidden/Hidden';
import { HeadTitle } from '@/components/Molecules/HeadMeta/HeadMeta';
import { CsrPdfViewer } from '@/components/Organisms/PDFViewer/CsrPdfViewer';
import type { IPDFViewerProps } from '@/components/Organisms/PDFViewer/PDFViewer';
import { useAppContext } from '@/contexts/AppContext/AppContext';
import type { FC, ReactNode } from 'react';
import { useEffect } from 'react';
import styles from './PDFPageTemplate.module.css';
interface IPDFPageTemplateProps {
  pageTitle: string;
  pdfViewerProps: IPDFViewerProps;
  children?: ReactNode;
}
export const PDFPageTemplate: FC<IPDFPageTemplateProps> = t0 => {
  const $ = _c(13);
  const {
    pdfViewerProps,
    pageTitle,
    children
  } = t0;
  const {
    isOfflineSession
  } = useAppContext();
  let t1;
  let t2;
  if ($[0] !== isOfflineSession) {
    t1 = () => {
      if (!isOfflineSession) {
        return;
      }
      document.body.style.setProperty("--print-message", "'Printing is not available in offline mode.'");
      return _temp;
    };
    t2 = [isOfflineSession];
    $[0] = isOfflineSession;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== pageTitle) {
    t3 = <HeadTitle title={pageTitle} />;
    t4 = <Hidden as="h1">{pageTitle}</Hidden>;
    $[3] = pageTitle;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== pdfViewerProps) {
    t5 = <div className={styles.viewArea}><CsrPdfViewer {...pdfViewerProps} /></div>;
    $[6] = pdfViewerProps;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== children || $[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <div className={styles.page} data-page-template="viewer">{t3}{t4}{t5}{children}</div>;
    $[8] = children;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp() {
  document.body.style.removeProperty("--print-message");
}